<script>
import { authComputed } from '@state/helpers'

export default {
  data() {
    return {
      drawer: false,
      group: null,
      persistentNavRoutes: [],
      loggedInNavRoutes: [
        {
          name: 'home',
          title: 'Home',
        },
        {
          name: 'profile',
          title: 'Settings',
        },
        {
          name: 'product-search',
          title: 'Product Search',
        },
        {
          name: 'my-products',
          title: 'My Products',
        },
        {
          name: 'custom-trackers',
          title: 'Custom Trackers',
        },
        {
          name: 'support',
          title: 'Help me',
        },
        {
          name: 'logout',
          title: 'Log out',
        },
      ],
      loggedOutNavRoutes: [
        {
          name: 'login',
          title: 'Log in',
        },
        {
          name: 'signup',
          title: 'Sign up',
        },
      ],
    }
  },
  computed: {
    ...authComputed,
  },
}
</script>

<template>
  <div :class="$style.navbarContainer">
    <v-app-bar color="indigo lighten-1" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title>
        <router-link :class="$style.clickableTitle" :to="{ name: 'home' }">
          Inventory Bot
        </router-link></v-toolbar-title
      >

      <v-spacer></v-spacer>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" absolute temporary>
      <v-list nav dense>
        <v-list-item-group
          v-model="group"
          active-class="deep-purple--text text--accent-4"
        >
          <v-list-item
            v-for="route in persistentNavRoutes"
            :key="route.name"
            :to="route"
          >
            <v-list-item-title>
              {{ route.title }}
            </v-list-item-title>
          </v-list-item>

          <div v-if="loggedIn">
            <v-list-item
              v-for="route in loggedInNavRoutes"
              :key="route.name"
              :to="route"
            >
              <v-list-item-title>
                {{ route.title }}
              </v-list-item-title>
            </v-list-item>
          </div>

          <div v-else>
            <v-list-item
              v-for="route in loggedOutNavRoutes"
              :key="route.name"
              :to="route"
            >
              <v-list-item-title>
                {{ route.title }}
              </v-list-item-title>
            </v-list-item>
          </div>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-row
      v-if="
        currentUser &&
          currentUser.notificationsEnabled === false &&
          (currentUser.dropCount > 0 ||
            currentUser.tags.length > 0 ||
            (currentUser.backup && currentUser.backup.length > 0))
      "
    >
      <v-col>
        <v-alert border="bottom" colored-border type="warning" elevation="2">
          Drops are disabled
          <BaseLink name="profile">in your settings</BaseLink>! You will not
          receive any notifications until you re-enable them.
        </v-alert>
      </v-col>
    </v-row>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  padding: 0;
  margin: 0 0 $size-grid-padding;
  text-align: center;
  list-style-type: none;

  > li {
    display: inline-block;
    margin-right: $size-grid-padding;
  }
}

.navbarContainer {
  margin-bottom: 10px;
}

a.clickableTitle {
  color: white !important;
  text-decoration: none;
}

.active a {
  font-weight: 600;
  color: $color-link-text-active;
  text-decoration: none;
  cursor: default;
}
</style>
